import { useState } from "react";

import { PageHead } from "@/components/PageHead";
import { Select } from "@/components/inputs";
import { AssetsInventory } from "@/modules/registry/AssetsInventory";
import { RegistryDevicesPage } from "@/modules/registry/DevicesPage";
import { PartsInventory } from "@/modules/registry/PartsInventory";

type What = "connection" | "part" | "asset";

/** ONE list of everything the registry knows: pick What (Connection · Part ·
 *  Asset), then filter. Drawers carry the per-thing detail and the
 *  relationship actions (install / remove). Enrolling and allocating live on
 *  their own doors — never here. */
export function RegistryInventoryPage() {
  const [what, setWhat] = useState<What>(() => {
    try { return (localStorage.getItem("reg.inventory.what") as What) || "part"; } catch { return "part"; }
  });
  const pick = (w: What) => { setWhat(w); try { localStorage.setItem("reg.inventory.what", w); } catch { /* ignore */ } };
  return (
    <div className="mpage on">
      <PageHead eyebrow="Registry" title="Inventory"
        desc="Everything registered: parts (a telematics unit is a part with a Connection ID, like a connected BMS) and assets (VIN / BIN). Connections is the technical view of the IMEI side: SIM, credential, FOTA state."
        right={
          <Select value={what} onChange={(e) => pick(e.target.value as What)} style={{ minWidth: 180 }}>
            <option value="part">Parts (telematics, BMS, motor ...)</option>
            <option value="asset">Assets (vehicles · batteries)</option>
            <option value="connection">Connections — technical (SIM, credential, FOTA)</option>
          </Select>
        } />
      {what === "connection" && <RegistryDevicesPage embedded />}
      {what === "part" && <PartsInventory />}
      {what === "asset" && <AssetsInventory />}
    </div>
  );
}
